import React, { Component } from "react";
import UserManagement from "../UserManagement/UserManagement";
import DocumentTemplates from "../DocumentTemplates/DocumentTemplates";
import TagsManagement from "../../components/TagsManagement/TagsManagement";

import "./AdminSettings.scss";
import OrganizationSettings from "../../components/OrganizationSettings/OrganizationSettings";

const AdminSettingsTabType = {
  USER_MANAGEMENT: "User Management",
  DOCUMENT_TEMPLATES: "Document Templates",
  TAG_MANAGEMENT: "Tag Management",
  ORGANIZATION_SETTINGS: "Organization Settings",
};

class AdminSettings extends Component {
  state = {
    tab: AdminSettingsTabType.USER_MANAGEMENT,
  };
  getComponent = () => {
    switch (this.state.tab) {
      case AdminSettingsTabType.USER_MANAGEMENT:
        return <UserManagement {...this.props} />;
      case AdminSettingsTabType.DOCUMENT_TEMPLATES:
        return <DocumentTemplates {...this.props} />;
      case AdminSettingsTabType.TAG_MANAGEMENT:
        return <TagsManagement />;
      case AdminSettingsTabType.ORGANIZATION_SETTINGS:
        return <OrganizationSettings />;
      default:
        return <UserManagement />;
    }
  };

  render() {
    return (
      <div className="container-fluid admin-settings-wraper">
        <div className="admin-settings-header">
          <h3>Admin Settings</h3>
        </div>
        <div className="admin-settings-body">
          <div className="tabs-container ">
            {Object.keys(AdminSettingsTabType).map((key) => (
              <div
                key={key}
                className={
                  AdminSettingsTabType[key] === this.state.tab
                    ? "tab active"
                    : "tab"
                }
                onClick={() => {
                  this.setState({
                    tab: AdminSettingsTabType[key],
                  });
                }}
              >
                {AdminSettingsTabType[key]}
              </div>
            ))}
          </div>
          <div className="tabs-body">{this.getComponent()}</div>
        </div>
      </div>
    );
  }
}

export default AdminSettings;
